/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, View, Text, Image, TouchableOpacity, Platform, Dimensions } from 'react-native'
// import styles from './Styles/AlertMessageStyles'
// import Modal from 'react-native-modalbox';

import { Images, Fonts } from '../Themes';
import I18n from "i18n-js"

const screenDimensions = Dimensions.get('window')
const screenWidth = screenDimensions.width
const screenHeight = screenDimensions.height

const styles = {
  container: {
    // justifyContent: `flex-end`,
    borderRadius: Platform.OS === 'ios' ? 10 : 0,
    width: Dimensions.get('window').width - 80,
    height: 120,
    overflow: "hidden",
    backgroundColor: 'white',
  },
}

export class ModalMessage extends Component {
  // <View style={{marginTop: 0, flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.5)' }}>
  render() {
    const {nearTop = false} = this.props
    return (
      <Modal animationType="slide" transparent={true} visible={this.props.visible}>
        <View style={{marginTop: 0, flex: 1, paddingTop: nearTop ? screenHeight * .15 : 0, justifyContent: nearTop ? 'flex-start' : 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          {this.props.children}
        </View>
      </Modal>)
  }
}

export class MoneyFaceMessage extends Component {
  render() {
    return (
      <ModalMessage {...this.props}>
        <View style={{ width : screenWidth * 0.7, backgroundColor : 'white', borderWidth: 1, borderColor: '#cccccc', borderRadius : 10 }}>
          <View style={{ height: 90, alignItems : 'center', justifyContent : 'center' }}>
            <Image style={{width: 60, height: 60}} source={Images.moneyFace}/>
          </View>
          <View style={{ alignItems : 'center', justifyContent : 'center', paddingLeft: 15, paddingRight: 15, paddingBottom: 20 }}>
            {this.props.children}
          </View>
          <TouchableOpacity style={{ height : 50, alignItems : 'center', justifyContent : 'center' }} onPress={this.props.onClose}>
            <Text style={{fontSize : 16, fontWeight: 'bold', fontFamily : Fonts.style.font.regular}}>{I18n.t("editpost.gotIt")}</Text>
          </TouchableOpacity>
        </View>
      </ModalMessage>)
  }
}

export class ThumbsDownMessage extends Component {
  render() {
    return (
      <ModalMessage {...this.props}>
        <View style={{ width : screenWidth * 0.7, backgroundColor : 'white', borderWidth: 1, borderColor: '#cccccc', borderRadius : 10 }}>
          <View style={{ height: 90, alignItems : 'center', justifyContent : 'center' }}>
            <Text style={{fontSize: 60}}>{`👎`}</Text>
          </View>
          <View style={{ alignItems : 'center', justifyContent : 'center', paddingLeft: 15, paddingRight: 15, paddingBottom: 20 }}>
            {this.props.children}
          </View>
          <TouchableOpacity style={{ height : 50, alignItems : 'center', justifyContent : 'center' }} onPress={this.props.onClose}>
            <Text style={{fontSize : 16, fontWeight: 'bold', fontFamily : Fonts.style.font.regular}}>{`Ok`}</Text>
          </TouchableOpacity>
        </View>
      </ModalMessage>)
  }
}
